import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
}), 'ChatBubble');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChatBubble.js
// module id = 2739
// module chunks = 2